export default __webpack_public_path__ + "static/sviluppo-software-10-trend-2024-cef1dc802148f9e0cf451ef4bb364450.jpg";